export const AUDIO_LEVEL_LOW = 'AUDIO_LEVEL_LOW'
export const AUDIO_LEVEL_NORMAL = 'AUDIO_LEVEL_NORMAL'

class AudioDetector {
  smoothing = 0.8
  rms = 0.0

  constructor(stream, context) {
    this.stream = stream
    this.context = context

    if (this.context == null) {
      return
    }

    this.script = this.context.createScriptProcessor()
    this.microphone = this.context.createMediaStreamSource(this.stream)

    this.script.onaudioprocess = (event) => this.handleAudioProcessingEvent(event)
  }

  handleAudioProcessingEvent(event) {
    const value = this.calculateRmsValue(
      event.inputBuffer.getChannelData(0)
    )

    this.setRmsValue(value)
  }

  calculateRmsValue(input) {
    let sum = 0

    for (let i = 0; i < input.length; i += 1) {
      sum += Math.abs(input[i])
    }

    return Math.sqrt(sum / input.length)
  }

  setRmsValue(value) {
    this.rms = Math.max(value, this.rms * this.smoothing)
  }

  getRmsValue() { return this.rms * 100 }

  start() {
    if (this.context == null) {
      return
    }

    this.microphone.connect(this.script)
    this.script.connect(this.context.destination)

    return this
  }

  stop() {
    if (this.context == null) {
      return
    }

    this.microphone.disconnect()
    this.script.disconnect()

    return this
  }

  getState() {
    if (this.getRmsValue() <= 15) {
      return AUDIO_LEVEL_LOW
    }

    return AUDIO_LEVEL_NORMAL
  }
}

export default AudioDetector
